import { useFormState } from 'react-hook-form';
import { hasDirtyFields } from './flattenDirtyFields';

/**
 * Fix per l'`isDirty` di react-hook-form che non funziona correttamente,
 * ed equivale piuttosto a un `isTouched`.
 * Vedi anche `useCoordinatedForm`.
 */
export function useFormStateIsDirty() {
  const { dirtyFields, isDirty: isTouched } = useFormState();

  // RHF non triggera il refresh sui `dirtyFields`, quindi non possiamo usare
  // `useMemo`, altrimenti non verrebbe mai aggiornato dopo il primo render, in
  // caso ci sia un `onChange` che modifica i valori del form (quindi imposta
  // isDirty a `true`), ma quei valori sono uguali a quelli iniziali (quindi
  // `dirtyFields` non cambia). Da quel punto in poi, `isDirty` rimane
  // sempre a `true` anche se il form è stato "riportato" allo stato iniziale,
  // quindi non viene più aggiornato.
  const isDirty = hasDirtyFields(dirtyFields);
  return isDirty;
}
